import { render, staticRenderFns } from "./DetalleGuarda.vue?vue&type=template&id=a517e1fe&scoped=true"
import script from "./DetalleGuarda.vue?vue&type=script&lang=js"
export * from "./DetalleGuarda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a517e1fe",
  null
  
)

export default component.exports